// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BmZd","fullView":"styles_fullView__1jO8X"};